// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import routes from './config/routes'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import store from './store/'
import components from './components/' // 加载公共组件
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import VueScroller from 'vue-scroller'
import resource from './pages/resource'

Object.keys(components).forEach((key) => {
  var name = key.replace(/(\w)/, (v) => v.toUpperCase()) // 首字母大写
  Vue.component(`v${name}`, components[key])
  console.log(key + ' ' + 'reg:' + name + components[key])
})

Vue.use(MuseUI)
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueScroller)
const router = new VueRouter({routes})
router.beforeEach(({meta, path}, from, next) => {
  console.log(`next: ${path}`)
  var { auth = true } = meta
  var isLogin = Boolean(store.state.user.userId) // true用户已登录， false用户未登录
  if (auth && !isLogin && path !== '/login') {
    // return next({ path: '/login' })
  }
  next()
})
window.resource = resource
window.$router = router
window.$store = store
new Vue({
  store,
  router,
  data: {
    eventHub: new Vue()
  }
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js